import Keycloak from 'keycloak-js';

const getDynamicKeycloakConfig = () => {
  // const domain = 'fcs-db.dev.farmsio.com';
  const domain = window.location.hostname;
  const parts = domain.split('.');

  let realmVariableName;
  let clientIdVariableName;

  if (domain.includes('.dev')) {
    realmVariableName = `REACT_APP_KEYCLOAK_REALM_${parts[0].toUpperCase()}_${parts[1].toUpperCase()}`;
    clientIdVariableName = `REACT_APP_KEYCLOAK_CLIENT_${parts[0].toUpperCase()}_${parts[1].toUpperCase()}`;
  } else if (domain.includes('.uat')) {
    realmVariableName = `REACT_APP_KEYCLOAK_REALM_${parts[0].toUpperCase()}_${parts[1].toUpperCase()}`;
    clientIdVariableName = `REACT_APP_KEYCLOAK_CLIENT_${parts[0].toUpperCase()}_${parts[1].toUpperCase()}`;
  } else {
    realmVariableName = `REACT_APP_KEYCLOAK_REALM_${parts[0].toUpperCase()}`;
    clientIdVariableName = `REACT_APP_KEYCLOAK_CLIENT_${parts[0]?.toUpperCase()}`;
  }

  const url = process.env.REACT_APP_AUTH_API_URL;
  const realm = process.env[realmVariableName];
  const clientId = process.env[clientIdVariableName];
  // const realm = 'Rplc-Dev';
  // const clientId = 'Rplc-Dev-Client';

  return { url, realm, clientId };
};

const keycloakConfig = getDynamicKeycloakConfig();

const keycloak = new Keycloak(keycloakConfig);

let initPromise;

export const initKeycloak = () => {
  if (!initPromise) {
    initPromise = keycloak
      .init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/silent-check-sso.html',
        checkLoginIframe: false,
        pkceMethod: 'S256',
        flow: 'standard'
      })
      .then(authenticated => {
        if (authenticated) {
          localStorage.setItem('token', keycloak.token);
          // refreshTokenPeriodically();
        } else {
          console.log('Not authenticated');
        }
        return authenticated;
      })
      .catch(error => {
        console.error('Failed to initialize Keycloak', error);
      });
  }
  return initPromise;
};

// const refreshTokenPeriodically = () => {
//   setInterval(() => {
//     keycloak.updateToken(70).then((refreshed) => {
//       if (refreshed) {
//         console.log('Token refreshed');
//         localStorage.setItem('token', keycloak.token);
//       } else {
//         console.log('Token not refreshed, valid for '
//           + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
//       }
//     }).catch(() => {
//       console.error('Failed to refresh token');
//     });
//   }, 60000); // Refresh token every minute
// };

export const login = () => {
  keycloak.login({
    redirectUri: window.location.origin
  });
};

// export const logout = () => {
//   const logoutUrl = `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/logout`;
//   keycloak.logout().then(() => {
//     // Clear any local storage items
//     localStorage.removeItem('token');
//     // Redirect to login page
//     window.location.href = logoutUrl;
//   });
// };

export default keycloak;
